module.exports = __webpack_public_path__ + "static/work64-27b2e7134c5488e92f044d0646fdc3b1.jpg";